module.exports = __webpack_public_path__ + "img/6_30.b5487dee.png";